import { FadeUp, Stagger, StaggerItem } from "./Motion";

const steps = [
  {
    n: "01",
    title: "Consent Captured",
    body:
      "The MSME grants consent via the Account Aggregator framework so verified data can be pulled securely on their behalf.",
  },
  {
    n: "02",
    title: "Data Collected",
    body:
      "Credablr auto-pulls 24 months of bank statements, GSTR-1/3B filing history, e-Invoice buyer/supplier links, and CIBIL Commercial credit history via secure APIs.",
  },
  {
    n: "03",
    title: "50+ Metrics Analysed",
    body:
      "Signals are normalised and evaluated across 50+ financial and operational metrics spanning two core pillars.",
  },
  {
    n: "04",
    title: "Faster Decisions",
    body:
      "A standardised Business Health Report — comparable, auditable, and lender-ready — flows into existing underwriting workflows.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how" className="relative py-24 md:py-36 border-t border-ink/10">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <FadeUp>
          <div className="flex items-center gap-6 mb-16">
            <span className="font-mono-cap text-ink/60">§ 03 — How It Works</span>
            <span className="hair-divider flex-1" />
          </div>
        </FadeUp>

        <div className="grid grid-cols-12 gap-6 md:gap-10 items-end">
          <div className="col-span-12 lg:col-span-8">
            <FadeUp>
              <h2 className="font-display text-5xl md:text-7xl text-ink leading-[0.98]">
                From scattered signals <br />
                to a <span className="italic text-teal">single verdict</span>.
              </h2>
            </FadeUp>
          </div>
        </div>

        <Stagger className="mt-20 md:mt-28 grid grid-cols-12 gap-y-16 md:gap-x-8">
          {steps.map((s, i) => (
            <StaggerItem key={s.n} className="col-span-12 md:col-span-3 relative">
              <div className="flex items-center gap-4">
                <div className="chapter-num text-6xl md:text-7xl text-teal">{s.n}</div>
                {i < steps.length - 1 && (
                  <div className="hidden md:block flex-1 h-px bg-ink/20 mt-6" />
                )}
              </div>
              <h3 className="font-display text-2xl md:text-3xl text-ink mt-6 leading-tight">
                {s.title}
              </h3>
              <p className="font-sans text-ink/70 mt-3 leading-relaxed text-sm md:text-base">
                {s.body}
              </p>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
